<template lang="html">
  <v-page class="page-terms">
    <v-container>
      <v-row class="justify-content-center">
        <v-col :md="9">
          <v-logo />

          <div class="terms-text" role="article">
            <h1>
              MANUAL DE BOAS PRÁTICAS E ORIENTAÇÕES AOS VIBBRANTES e FREELANCERS
              VIBBRA
            </h1>

            <p>Última modificação: 08 de Julho de 2019.</p>

            <p>
              Este documento tem por objetivo orientar as atividades e o
              comportamento mínimo esperado para que um Vibbrante ou Talent
              Vibbra atinja seus objetivos, quanto a qualidade de seu
              atendimento e de suas entregas aos clientes em contratos junto à
              Vibbra.
            </p>

            <p>
              Em caso de alguma dúvida, deve entrar em contato pelo email
              <b>apoio-vibbrantes@vibbra.com.br.</b>
            </p>

            <h2>
              Contato com o cliente antes do fechamento do contrato e a compra
              de créditos
            </h2>
            <p>
              O contato direto com o cliente antes do fechamento do contrato e
              da compra de créditos é exclusivamente através da ferramenta de
              Mensagens pela Plataforma Vibbra, além de ser mediado pela nossa
              equipe comercial.
            </p>
            <p>
              Neste momento não pode haver troca de informações de contato, como
              e-mail, telefone, skype, etc. Apenas após a assinatura do contrato
              pelo profissional e pelo cliente, e a compra de créditos, é que o
              cliente terá acesso a todos os seus dados de contato. Sendo assim,
              para fazer reuniões via call, o cliente precisa comprar ao menos
              1h sua na Plataforma.
            </p>
            <p>
              Entendemos que você já passou por nosso processo de seleção e faz
              parte da nossa rede, logo, o seu tempo precisa ser valorizado,
              mesmo que seja 1h de reunião. Além disso, faz-se necessária a
              nossa cobertura contratual para trazer segurança às informações
              que serão trocadas por fora da nossa Plataforma.
            </p>
            <p>
              Nossa equipe comercial sempre orienta o cliente quanto a essa
              questão, caso seja imprescindível essa conversa, mas você, como
              parte de nossa rede, tem liberdade para reforçar essa questão com
              ele.
            </p>
            <p>Aproveite este momento antes do fechamento do contrato para:</p>
            <p>1. Tirar dúvidas quanto as exigências técnicas do projeto.</p>
            <p>
              2. Pedir mais detalhes da demanda e em caso de solicitação de
              estimativa, pedir um link compartilhado com um detalhamento mais
              claro do escopo a ser estimado.
            </p>
            <p>
              3. Se solicitada uma estimativa, foque em estimar apenas em horas,
              pois seu valor/hora já está na plataforma e o custo considera
              sempre horas x seu valor de hora. Repasses de orçamentos em
              valores serão vetados.
            </p>
            <p>4. Deixar clara a sua disponibilidade semanal para a demanda.</p>
            <p>
              Precisa de ajuda com o cliente? Fale com a nossa equipe comercial
              nesse momento pré fechamento de contrato, pois ela pode ajudá-lo a
              achar meios para viabilizar o contrato e você não perder a
              oportunidade. Basta entrar em contato através do email
              <b>leandro.oliveira@vibbra.com.br</b> ou do WhatsApp
              <b>(48) 9 9116 4123</b>.
            </p>

            <h2>Reunião de kickoff com o cliente</h2>
            <p>
              A reunião de kickoff é a primeira reunião formal entre cliente e
              profissional, logo após os acertos contratuais. Essa reunião deve
              obrigatoriamente cumprir os seguintes requisitos.
            </p>
            <p>
              1. Deve ser agendada o mais breve possível após a ativação do
              contrato na plataforma, não ultrapassando o prazo de 2 dias úteis.
              Caso o cliente não entre em contato primeiro, o profissional deve
              estabelecer esse primeiro contato dentro do prazo mencionado.
            </p>
            <p>
              2. Devem estar presentes minimamente o profissional e o
              responsável por parte do cliente, que irá acompanhar o andamento
              dos trabalhos.
            </p>
            <p>
              3. Deve ser combinada a forma de comunicação entre profissional e
              cliente, sendo todas elas documentadas, seja através da própria
              ferramenta escolhida (troca de emails, Slack, chats, etc), seja
              através de uma breve "ata" enviada por email para todos com os
              principais pontos conversado, em caso de reuniões via voz. No caso
              de "ata", é necessário a aprovação de todos.
            </p>
            <p>
              4. Deve ser combinada a forma de trabalho, bem como a frequência e
              horários para as reuniões de alinhamento, de modo que funcione bem
              para o profissional e o cliente. Lembrando que todas as
              comunicações precisam ser registradas.
            </p>
            <p>
              5. Deve ficar claro entre as partes a expectativa de entrega do
              cliente, o que de fato será entregue em termos palpáveis, seu
              formato e conteúdo esperados (abrangência das informações),
              definindo os limites e deixando claro o que NÃO será entregue.
            </p>
            <p>
              6. Por fim, o profissional deve avaliar e notificar o cliente caso
              o volume de horas contratado não seja suficiente para o trabalho
              esperado. Deve-se então definir junto com o cliente se haverá um
              aumento de horas, ou se o trabalho será reduzido para caber no
              pacote contratado. Em caso de adendo de horas, o proprio cliente
              pode realizar a contratação na Plataforma, ou a Vibbra deve ser
              notificada para ajudá-lo nesse processo.
            </p>

            <h2>Adaptação do Vibbrante às ferramentas que o cliente usa</h2>
            <p>
              Na maioria dos casos o cliente já utiliza ferramentas para
              executar seus projetos, tais como Slack, Trello, Github, InVision,
              etc. Por isso, é necessário que o profissional se adeque a essas
              ferramentas, para que o cliente não tenha barreiras que possam
              gerar atritos logo no início dos trabalhos.
            </p>
            <p>
              Obviamente, nada impede uma negociação junto ao cliente para que
              ele se adapte ao processo usual do profissional, porém, não pode
              ser impositivo e/ou impeditivo para o andamento dos trabalhos.
            </p>

            <h2>A comunicação com o cliente deve ser rotineira</h2>
            <p>
              Como atuamos com trabalho remoto, é imprescindível uma comunicação
              constante com o cliente, com um delay que não ultrapasse 2 turnos
              (8 horas), seguindo os parâmetros estabelecidos na reunião de
              kickoff.
            </p>
            <p>
              Demoras na comunicação interferem diretamente no andamento dos
              projetos, consequentemente no consumo e pagamento das horas, bem
              como na satisfação do profissional e do cliente com o projeto,
              muitas vezes podendo gerar o cancelamento do contrato.
            </p>

            <h2>
              Somente executar atividades que foram explicitamente alinhadas
            </h2>
            <p>
              Toda hora trabalhada dentro do pacote contratado e reportada na
              Plataforma, será cobrada do cliente, portanto, cada atividade que
              o profissional for executar, deve estar plenamente alinhada com o
              cliente, inclusive destacando se cabem ou não no volume de horas
              contratado, para que não haja contestações futuras.
            </p>
            <p>
              Caso as atividades não caibam nas horas contratadas, deve-se
              seguir as orientações do item abaixo.
            </p>

            <h2>Aviso a Vibbra em caso de pedidos de horas adicionais</h2>
            <p>
              Nenhuma e qualquer atividade que extrapole o volume de horas
              contratadas e liberadas na Plataforma pelo cliente, deve ser
              executado pelo profissional.
            </p>
            <p>
              Em caso do profissional perceber que o volume de horas disponíveis
              não contemplará todas as atividades que o cliente solicita, o
              mesmo deve notificar o cliente disso e lhe passar uma estimativa
              de horas a mais que seriam necessárias, para que o cliente
              contrate como adicional. Após isso, o profissional deve notificar
              a Vibbra e solicitar que o cliente formalize essa contratação na
              Plataforma, para que então possa seguir os trabalhos.
            </p>
            <p>
              Horas adicionais trabalhadas sem uma formalização contratual na
              Plataforma, não serão pagas.
            </p>

            <h2>Deve-se alertar o cliente quanto ao desperdício de horas</h2>
            <p>
              É comum em casos de clientes afastados da tecnologia, a mudança
              constante do escopo de atividades que o profissional deve executar
              nas horas contratadas. Caso o profissional perceba essa
              indefinição, deve alertar o cliente de que todas as horas gastas
              com tais mudanças, serão consumidas do pacote de horas contratado,
              o que pode gerar desperdícios.
            </p>
            <p>
              De qualquer forma, após o cliente ser alertado, estas horas devem
              ser reportadas na Plataforma para serem pagas.
            </p>

            <h2>Reporte de horas na plataforma</h2>
            <p>
              É altamente recomendado que o profissional reporte as horas e
              atividades na plataforma Vibbra sempre após concluí-las, mesmo que
              seja diariamente. Isso não exclui o uso de outras ferramentas de
              gestão que o cliente queira aplicar, conforme já mencionado. Mas é
              fundamental reportar as horas na Plataforma para que tanto a
              Vibbra quanto o cliente saibam do andamento do contrato, além de
              ser o único meio de corroborar o que foi trabalhado para que o
              profissional receba por isso após a aprovação do cliente.
            </p>

            <h2>Formalizando entregas</h2>
            <p>
              Todo o material resultante das atividades do profissional, seja
              ele código-fonte, documentos, imagens, etc, é de total propriedade
              do cliente e deve ser inteiramente repassado ao mesmo após a
              conclusão das horas contratadas.
            </p>
            <p>
              Lembre-se de formalizar um e-mail quando finalizar as horas e
              concluir o contrato.
            </p>
            <p>
              Sempre peça ao cliente para avaliar o seu desempenho na
              Plataforma, pois assim você valoriza o seu perfil e ganha destaque
              para novas contratações.
            </p>

            <h2>Tentativa de contratação por fora da plataforma - by pass</h2>
            <p>
              By pass é a relação do cliente com o profissional por fora da
              plataforma, contemplando compra de horas ou relações comerciais
              sem a intermediação da Vibbra. Lembre-se que a Vibbra existe para
              que essa relação seja segura para ambas as partes, além de não
              garantirmos o pagamento de algo realizado por fora, não há
              cobertura de contrato e tanto cliente quanto o profissional
              estarão sujeitos às penalidades jurídicas do contrato inicialmente
              firmado e dos nossos Termo de Uso assinados no momento do cadastro
              na Plataforma.
            </p>

            <h2>A Equipe Vibbra está aqui para te apoiar!</h2>
            <p>
              Estamos constantemente buscando evoluir e fornecer o apoio que
              nossos profissionais precisam para realizar um ótimo trabalho.
              Portanto, fique sempre a vontade para entrar em contato com a
              nossa equipe que iremos ajudá-lo!
            </p>
            <hr />
            <p><b>Equipe Vibbra</b></p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
export default {};
</script>

<style lang="scss">
.terms-text {
  font-size: 0.9em;
  h1 {
    font-size: 1.8em;
  }
  h2 {
    font-size: 1.6em;
  }
}
.page-terms {
  .logo {
    width: 200px;
    margin: 0 auto 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/manual.vue